import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  BENEFIT_ACTION_TYPE,
  resolveBenefitActionType,
} from "src/constants/milestones";
import {
  Milestone,
  MilestoneBenefit,
  MilestoneBenefitAction,
} from "src/types/program.types";

// Turns `action.params` into a query string so a destination can read them
// (?coachType=nutrition) without another round of prop threading.
const toSearchParams = (params?: Record<string, any> | null) => {
  const entries = Object.entries(params || {}).filter(
    ([, value]) => value !== null && value !== undefined && value !== "",
  );
  if (entries.length === 0) return "";
  return `?${new URLSearchParams(
    entries.map(([key, value]) => [key, String(value)]),
  ).toString()}`;
};

// Routes a milestone benefit's action to its screen. Shared by the program
// details screen and the home card so both behave the same.
export const useBenefitAction = () => {
  const navigate = useNavigate();
  const params = useParams();
  const supportProgramKey = params["support-program-key"];

  return useCallback(
    (
      milestone: Milestone,
      benefit: MilestoneBenefit,
      action: MilestoneBenefitAction,
    ) => {
      const actionType = resolveBenefitActionType(action?.type);

      switch (actionType) {
        case BENEFIT_ACTION_TYPE.ADDRESS_COLLECTION:
          navigate(`/app/${supportProgramKey}/program-details/claim-details`, {
            state: { milestone, benefit, action },
          });
          break;

        case BENEFIT_ACTION_TYPE.NAVIGATE_TO_APPOINTMENTS:
          navigate(
            `/app/${supportProgramKey}/book-consultation${toSearchParams(
              action?.params,
            )}`,
          );
          break;

        default:
          console.warn(
            "Unhandled benefit action",
            milestone.key,
            benefit.title,
            action?.type,
          );
      }
    },
    [navigate, supportProgramKey],
  );
};

export default useBenefitAction;
